<template>
    <div class="px-4 pb-2 pt-1">
      <v-row>
        <div
          :class="show ? 'col-12' : 'col-12' "
        >
          <v-card elevation="0" style="height: 100%;">
            <v-card-title style="cursor: pointer;" class="d-flex justify-space-between align-center">
              <div>
              <!----  <v-icon class="mr-2">-->
                <!----   {{show ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}}-->
              <!----   </v-icon>-->
                {{  $t('_informations_') }}
              </div>
            </v-card-title>

            <hr v-show="show" />

            <v-card-text >
              <v-row v-show="show">
                <v-col
                  v-for="information in informations"
                  :key="information.index"
                  :class="information.index == 'address' ? 'col-3' : ''"
                >
                  <div>
                    {{ information.text }}
                  </div>
                  <div class="dark--text">
                    <span>{{ installation[information.index] }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>

            <hr v-show="show" />

            <div style="display: flex;" >
                <dashboardinformation :liste_dashboard="list_total"/>
                <v-card style="flex: 1; margin-top: 10px; margin-left: 5px; margin-right: 10px;" elevation="0">
                  <Mapinformation :liste_parc="list_parc" :selectsite="nbr_site"/>
                </v-card>
            </div>
          </v-card>
        </div>
      </v-row>
    </div>
</template>

<script>
import Mapinformation from "./MapInformation.vue";
import dashboardinformation from "./DashboardInformation.vue";

export default {
  components: {
    Mapinformation,
    dashboardinformation
  },

  props: {
    selected_date: {
      type: String,
      required: false
    },
    list_parc: {
      type: Array,
      required: false      
    },
    list_total: {
      type: Array,
      required: false
    },
    nbr_site: {
      type: Array,
      required: false
    }
  },
    data(){
    return {
      informations: [],
      show: true
    }
  },
 watch:{
  selected_date:{
      handler(){
        this.list_total
      } 
  },
  "$root.$i18n.locale": {
      async handler() {
        await this.refresh_header_values()
      },
      immediate: true,
      deep: true,
    },
    '$route': {
        async handler() {
          await this.refresh_header_values()  
        
        },
        immediate: true,
      },  
 },
  computed: {
    installation() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      );
    },
  },

  methods: {
    toggleCard() {
      this.show = !this.show
    },
    refresh_header_values(){
        this.informations =[
        {
          index: "build_date",
          text: this.$t('_mise_en_service_'),
        },
        {
          index: "address",
          text: this.$t('_adresse_'),
        },
        {
          index: "installation_type",
          text: this.$t('_type_d_installation_inclinaison_orientation_'),
        },
        {
          index: "company_name",
          text: this.$t('_groupe_'),
        },
        {
          index: "installed_power_kwc",
          text: this.$t('_puissance_crete_(kwc)_'),
        },
      ]

      },
  }
}
</script>

<style>
hr {
  margin: 0 14px;
  border: 0;
  border-top: 1px solid lightgray;
}
</style>